import { TableActionCellProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TableActionCellProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TableActionCellProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      primaryAction: {
        text: 'Edit',
        skin: 'inverted',
        onClick: () => ({}),
      },
    } as TableActionCellProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
